import { IMAGE_ACTIONS } from "../actionTypes";

export const preloadScreenBackgrounds = () => {
	return { type: IMAGE_ACTIONS.PRELOAD_SCREEN_BACKGROUNDS };
};
